export default "__VITE_ASSET__DVjI1A1d__"